module.exports = __webpack_public_path__ + "img/SKMJ_net1.4ff36208.png";